import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import GeofenceManagement from './GeofenceManagement';

const AdminGeofencePage = ({ dashboardHomePath = '/admin' }) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold">Geofence Summary</h2>
          <p className="text-sm text-muted-foreground">Dedicated page for geofence locations and coverage summary.</p>
        </div>
        <Button variant="outline" onClick={() => navigate(dashboardHomePath)}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
      </div>
      <GeofenceManagement />
    </div>
  );
};

export default AdminGeofencePage;
